/**
 * Retrieves the value of a cookie by its name.
 * @param name The name of the cookie.
 * @returns The cookie's value, or an empty string if not found.
 */
export const getCookie = (name: string): string => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return '';
};

export const toPascalCase = (upperCaseStr: string): string => {
    return upperCaseStr.toLowerCase()
    .split(/[\s_-]+/) // split by space, underscore, or hyphen
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export const hexToRgba = (hex: string, alpha?: number): string => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  return `rgba(${r}, ${g}, ${b}${alpha ? ', ' + alpha : '1'})`;
}